import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { symbolIndexFileIsReadyAsync } from '../symbol-index/lifecycle/symbol-index-file-ready.js';

export const CODE_NAV_INDEX_READY_WAIT_MS = 75;
export const CODE_NAV_INDEX_READY_POLL_MS = 15;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Poll SQLite for indexed content without running indexing on the main thread. */
export async function waitForSymbolIndexReady(
  sessionParentPath: string,
  reqPath: string,
  maxWaitMs = CODE_NAV_INDEX_READY_WAIT_MS,
): Promise<boolean> {
  const deadline = Date.now() + maxWaitMs;
  do {
    if (isCliImmediateShutdownRequested()) return false;
    if (await symbolIndexFileIsReadyAsync(sessionParentPath, reqPath)) return true;
    await delay(CODE_NAV_INDEX_READY_POLL_MS);
    await yieldToEventLoop();
  } while (Date.now() < deadline);
  return await symbolIndexFileIsReadyAsync(sessionParentPath, reqPath);
}
